import { AdminRoutePath, RoutePath } from '../../constants';

const PUBLIC_ADMIN_PATHS = new Set([
  `${RoutePath.ADMIN}${AdminRoutePath.LOGIN}`,
  `${RoutePath.ADMIN}${AdminRoutePath.OAUTH_CALLBACK}`,
]);

export const isAuthenticatedAdminRoute = (pathname: string): boolean => {
  if (!pathname.startsWith(RoutePath.ADMIN)) {
    return false;
  }

  return !PUBLIC_ADMIN_PATHS.has(pathname);
};
